import styles from './index.module.scss';
import SectionPro from '../components/SectionPro';
import EFPicture from '@elem/compCommon/EFPicture';
import Right from './icons/right';
import Plus from './icons/plus';

const Support: React.FC = () => {
    return (
        <div className={`${styles.Support} GtmModuleData-section`} data-section-id={styles.Support} data-section-title={'2kWhの大容量 & 最大6kWhの容量拡張'}>
            <SectionPro
                label="2kWhの大容量 & 最大6kWhの容量拡張"
                title="柔軟な容量拡張で大人数や長期間の車中泊や非常時でも安心"
                desc="DELTA 2 Maxは、1台で約2日間の車中泊にピッタリな2000Whの大容量。防災グッズと合わせて活用すれば、災害時には車内がプライバシーも確保できる避難所に早変わり。ニーズに合わせてエクストラバッテリーを使用することで、最大6144Whの大容量で十分な電力を確保します。大人数や長期間の車中泊はもちろん、安全・安心の車中泊避難、自宅での防災・停電時用バックアップとしても活躍します。"
            >
                <div className="wrapper">
                    <EFPicture
                        src="https://websiteoss.ecoflow.com/upload/image/1744342827803/D2M%2BEB%20(1).png"
                        srcPad="https://websiteoss.ecoflow.com/upload/image/1745398689108/%E5%AE%B9%E9%87%8F%E6%8B%A1%E5%BC%B5-pad.jpg"
                        srcMobile="https://websiteoss.ecoflow.com/upload/image/1745398689349/%E5%AE%B9%E9%87%8F%E6%8B%A1%E5%BC%B5-h5.jpg"
                    />

                    <div className="box-wrapper">
                        <div className="mask"></div>
                        <div className="pc-box-row">
                            <div className="box-col col-1 flex-row">
                                <span className="title h1">4096Wh</span>
                                <Right className="icon" width="15" height="15" />
                            </div>
                            <div className="box-col flex-row col-2">
                                <div className="img-wrapper">
                                    <EFPicture src="https://websiteoss.ecoflow.com/upload/image/1745374705320/sl_ds%20(2)%20(1).png" />
                                </div>
                                <div className="flex-col">
                                    <span className="title">DELTA 2 Max</span>
                                    <span className="title h2">2048Wh</span>
                                </div>
                                <Plus />
                            </div>
                            <div className="box-col flex-row">
                                <div className="img-wrapper">
                                    <EFPicture src="https://websiteoss.ecoflow.com/upload/image/1745374705320/sl_ds%20(2)%20(1).png" />
                                </div>
                                <div className="flex-col">
                                    <span className="title">DELTA 2 Max </span>
                                    <span className="title">エクストラバッテリー1台</span>
                                    <span className="title h2">2048Wh</span>
                                </div>
                            </div>
                        </div>
                        <div className="pc-box-row">
                            <div className="box-col col-1 flex-row">
                                <span className="title h1">6144Wh</span>
                                <Right className="icon" width="15" height="15" />
                            </div>
                            <div className="box-col flex-row col-2">
                                <div className="img-wrapper">
                                    <EFPicture src="https://websiteoss.ecoflow.com/upload/image/1745374705320/sl_ds%20(2)%20(1).png" />
                                </div>
                                <div className="flex-col">
                                    <span className="title">DELTA 2 Max</span>
                                    <span className="title h2">2048Wh</span>
                                </div>
                                <Plus />
                            </div>
                            <div className="box-col flex-row">
                                <div className="img-wrapper">
                                    <EFPicture src="https://websiteoss.ecoflow.com/upload/image/1745374705320/sl_ds%20(2)%20(1).png" />
                                </div>
                                <div className="img-wrapper left">
                                    <EFPicture src="https://websiteoss.ecoflow.com/upload/image/1745374705320/sl_ds%20(2)%20(1).png" />
                                </div>
                                <div className="flex-col">
                                    <span className="title">DELTA 2 Max </span>
                                    <span className="title">エクストラバッテリー2台</span>
                                    <span className="title h2">4096Wh</span>
                                </div>
                            </div>
                        </div>

                        <div className="pad-box-row">
                            <div className="title h1 header">4096Wh</div>
                            <div className="bottom">
                                <div className="block">
                                    <EFPicture src="https://websiteoss.ecoflow.com/upload/image/1745374705320/sl_ds%20(2)%20(1).png" />

                                    <div className="text-block">
                                        <span className="title">DELTA 2 Max</span>
                                        <span className="title h2">2048Wh</span>
                                    </div>
                                </div>
                                <Plus className="plus-icon" />
                                <div className="block">
                                    <EFPicture src="https://websiteoss.ecoflow.com/upload/image/1745374705320/sl_ds%20(2)%20(1).png" />
                                    <div className="text-block">
                                        <span className="title">DELTA 2 Max</span>
                                        <span className="title">エクストラバッテリー1台</span>
                                        <span className="title h2">2048Wh</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="pad-box-row">
                            <div className="title h1 header">6144Wh</div>
                            <div className="bottom">
                                <div className="block">
                                    <EFPicture src="https://websiteoss.ecoflow.com/upload/image/1745374705320/sl_ds%20(2)%20(1).png" />

                                    <div className="text-block">
                                        <span className="title">DELTA 2 Max</span>
                                        <span className="title h2">2048Wh</span>
                                    </div>
                                </div>
                                <Plus className="plus-icon" />
                                <div className="block">
                                    <div className="block-img-wrapper">
                                        <EFPicture src="https://websiteoss.ecoflow.com/upload/image/1745374705320/sl_ds%20(2)%20(1).png" />
                                        <EFPicture src="https://websiteoss.ecoflow.com/upload/image/1745374705320/sl_ds%20(2)%20(1).png" />
                                    </div>
                                    <div className="text-block">
                                        <span className="title">DELTA 2 Max</span>
                                        <span className="title">エクストラバッテリー2台</span>
                                        <span className="title h2">4096Wh</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </SectionPro>
        </div>
    );
};

export default Support;
